export default {
  title: '變更密碼',
  form: {
    account: {
      label: '帳號',
      placeholder: '請輸入帳號'
    },
    password: {
      label: '密碼',
      placeholder: '請輸入密碼',
      hint: '8~20半形英文、數字，大小寫需區分',
      feedback: {
        regex: '需包含至少一個大寫、小寫英文及數字，至少包含8位字元',
        accountDuplicate: '密碼不可與帳號相同',
        historyFail: '不符合密碼歷程限制'
      }
    },
    confirmPassword: {
      label: '確認密碼',
      placeholder: '請輸入密碼',
      feedback: {
        equal: '請再次輸入相同的密碼'
      }
    },
    submit: '變更密碼'
  },
  unauthorized: '登入驗證已過期，請重新登入',
  success: '變更密碼成功，請重新登入'
};
